// Common Vietnamese translations
export const commonVi = {
  'action': 'Hành Động',
  'actions': 'Thao Tác',
  'active': 'Hoạt Động',
  'add.by.image': 'Thêm bằng hình ảnh',
  'add.manually': 'Thêm thủ công',
  'address': 'Địa Chỉ',
  'admin': 'Quản Trị Viên',
  'affected.date': 'Ngày Có Hiệu Lực',
  'all': 'Tất Cả',
  'all.actions': 'Tất Cả Hành Động',
  'all.capacities': 'Tất Cả Trọng Tải',
  'all.records': 'Tất Cả Hồ Sơ',
  'all.types': 'Tất Cả Loại',
  'amount': 'Số tiền',
  'attach.receipt': 'Đính kèm hóa đơn (không bắt buộc)',
  'average': 'Trung Bình',
  'average.efficiency': 'Hiệu Suất Trung Bình',
  'back': 'Quay Lại',
  'back.to.dashboard': 'Quay Lại Bảng Điều Khiển',
  'best': 'Tốt Nhất',
  'best.efficiency': 'Hiệu Suất Tốt Nhất',
  'brand': 'Thương Hiệu',
  'calculate.l.per.100km': 'Tính L/100km',
  'cancel': 'Hủy',
  'cannot.delete.selected.model': 'Không thể xóa mô hình hiện đang được chọn',
  'change': 'Thay đổi',
  'change.date': 'Ngày Thay Đổi',
  'changed.by': 'Thay Đổi Bởi',
  'clear': 'Xóa',
  'click.save.to.store': 'Nhấp vào nút "Lưu" trong cột Thao Tác để lưu từng tài liệu dưới dạng nháp.',
  'close': 'Đóng',
  'color': 'Màu Sắc',
  'company.name': 'Tên Công Ty',
  'confirm.delete': 'Xác Nhận Xóa',
  'confirm.password': 'Xác Nhận Mật Khẩu',
  'confirm.restore.record': 'Bạn có chắc chắn muốn khôi phục hồ sơ này không?',
  'cost': 'Chi Phí',
  'create': 'Tạo',
  'created': 'Đã Tạo',
  'created.at': 'Tạo Lúc',
  'created.by': 'Tạo Bởi',
  'created.receipts': 'Hóa đơn đã tạo',
  'created.records': 'Hồ Sơ Đã Tạo',
  'current.file': 'Tệp hiện tại',
  'current.image': 'Ảnh hiện tại',
  'current.tax.rate': 'Tỷ Lệ Thuế Hiện Tại',
  'currently.processing': 'Đang xử lý',
  'dashboard': 'Bảng Điều Khiển',
  'date': 'Ngày',
  'date.of.birth': 'Ngày Sinh',
  'date.range': 'Khoảng Thời Gian',
  'date.range.label': 'Khoảng Thời Gian',
  'default.admin.info': 'Admin mặc định: tên đăng nhập = "admin", mật khẩu = "admin123"',
  'delete': 'Xóa',
  'delete.confirm': 'Bạn có chắc chắn muốn xóa mục này không?',
  'delete.current.file.confirm': 'Bạn có chắc chắn muốn xóa tệp hiện tại không?',
  'delete.file': 'Xóa tệp',
  'deleted': 'Đã Xóa',
  'deleted.at': 'Xóa Lúc',
  'deleted.by': 'Xóa Bởi',
  'deleted.records': 'Hồ Sơ Đã Xóa',
  'description': 'Mô Tả',
  'destination': 'Điểm Đến',
  'destinationProvince': 'Tỉnh',
  'distance': 'Quãng Đường',
  'district': 'Quận/Huyện',
  'district.list': 'Danh Sách Quận/Huyện',
  'district.management': 'Quản Lý Quận/Huyện',
  'draft': 'Nháp',
  'draft.receipts': 'Hóa đơn nháp',
  'edit': 'Chỉnh Sửa',
  'effective.date': 'Ngày Có Hiệu Lực',
  'efficiency': 'Hiệu Suất',
  'efficiency.trend': 'Xu Hướng Hiệu Suất',
  'emergency.contact': 'Liên Hệ Khẩn Cấp',
  'enter.description': 'Nhập mô tả',
  'enter.model.name': 'Nhập tên mô hình',
  'error.fetching.data': 'Lỗi khi tải dữ liệu',
  'expiry.date': 'Ngày Hết Hạn',
  'export.all.data': 'Xuất Tất Cả Dữ Liệu',
  'export.data': 'Xuất Dữ Liệu',
  'export.description': 'Tải xuống toàn bộ dữ liệu hệ thống dưới dạng tệp JSON',
  'export.error': 'Lỗi khi xuất dữ liệu',
  'export.success': 'Xuất dữ liệu thành công',
  'export.to.excel': 'Xuất Ra Excel',
  'exporting': 'Đang Xuất',
  'file.deleted.successfully': 'Xóa tệp thành công',
  'file.name': 'Tên Tệp',
  'file.processed.successfully': 'Tệp đã được xử lý thành công',
  'file.ready': 'Tệp đã sẵn sàng',
  'file.too.large': 'Tệp quá lớn. Kích thước tối đa là 10MB.',
  'files.processed.sequentially': 'Các tệp được xử lý từng cái một để đảm bảo ổn định. Vui lòng đợi cho đến khi tất cả tệp hoàn thành.',
  'files.selected': 'tệp đã chọn',
  'filter.by.link.status': 'Lọc Theo Trạng Thái Liên Kết',
  'filters': 'Bộ Lọc',
  'finalize': 'Hoàn tất',
  'first.name': 'Tên',
  'found.matches': 'Tìm Thấy Khớp',
  'from.date': 'Từ Ngày',
  'from.to': 'Từ - Đến',
  'history': 'Lịch Sử',
  'image.processed.successfully': 'Xử lý hình ảnh thành công',
  'import.data': 'Nhập Dữ Liệu',
  'import.description': 'Tải lên tệp JSON để nhập dữ liệu vào hệ thống',
  'import.error': 'Lỗi khi nhập dữ liệu',
  'import.success': 'Nhập dữ liệu thành công',
  'importing': 'Đang Nhập',
  'inactive': 'Không Hoạt Động',
  'insurance.expiry': 'Hết Hạn Bảo Hiểm',
  'invalid.file.type': 'Định dạng tệp không hợp lệ. Vui lòng tải lên hình ảnh hoặc tệp PDF.',
  'is.active': 'Đang Hoạt Động',
  'language': 'Ngôn Ngữ',
  'last.30.days.records': 'Bản ghi 30 ngày gần đây',
  'last.name': 'Họ',
  'last.update': 'Cập Nhật Lần Cuối',
  'leave.empty.for.all.capacities': 'Để trống để áp dụng cho tất cả các loại trọng tải xe',
  'legend': 'Chú Thích',
  'license.expiry': 'Hết Hạn Giấy Phép',
  'license.number': 'Số Giấy Phép Lái Xe',
  'link': 'Liên Kết',
  'link.status': 'Trạng Thái Liên Kết',
  'linked': 'Đã Liên Kết',
  'linked.records': 'Hồ Sơ Đã Liên Kết',
  'location': 'Địa Điểm',
  'location.type': 'Loại Địa Điểm',
  'logging.in': 'Đang đăng nhập...',
  'login': 'Đăng Nhập',
  'logout': 'Đăng Xuất',
  'mark.as.created': 'Đánh Dấu Đã Tạo',
  'message': 'Thông Báo',
  'mode.save.description': 'Xử lý tài liệu, trích xuất dữ liệu, và tự động lưu dưới dạng bản ghi nháp (trạng thái WaitForProcess/Pending) để xem xét sau',
  'mode.view.description': 'Xử lý tài liệu và xem dữ liệu trích xuất mà không lưu vào cơ sở dữ liệu. Bạn có thể lưu từng tài liệu sau.',
  'model': 'Mẫu Xe',
  'model.description': 'Mô Tả',
  'model.name': 'Tên Mô Hình',
  'more': 'thêm',
  'more.districts': 'quận/huyện khác',
  'moving': 'Đang Di Chuyển',
  'n.a': 'N/A',
  'name': 'Tên',
  'no': 'Không',
  'no.data': 'Không có dữ liệu',
  'no.data.available': 'Không có dữ liệu',
  'no.data.for.date': 'Không có dữ liệu cho ngày này',
  'no.deleted.records': 'Không có hồ sơ nào đã bị xóa',
  'no.description': 'Không Có Mô Tả',
  'no.districts.applies.to.all': 'Không có quận/huyện (áp dụng cho tất cả)',
  'no.districts.selected': 'Không có quận/huyện nào được chọn - RM2 sẽ áp dụng cho điểm đến vận chuyển KHÔNG có trong danh sách quận/huyện nào',
  'no.efficiency.data': 'Không có dữ liệu hiệu suất nhiên liệu',
  'no.file.selected': 'Chưa chọn tệp',
  'no.image': 'Không có ảnh',
  'no.position': 'Chưa Có Vị Trí',
  'no.position.data': 'Không có dữ liệu vị trí',
  'no.records.match.filters': 'Không có bản ghi nào phù hợp với bộ lọc',
  'notes': 'Ghi Chú',
  'overall.statistics': 'Thống Kê Tổng Quan',
  'password': 'Mật Khẩu',
  'periods': 'Giai Đoạn',
  'phone': 'Số Điện Thoại',
  'please.enter.valid.total': 'Vui lòng nhập tổng số tiền hợp lệ',
  'please.input': 'Vui lòng nhập',
  'please.provide.reason.for.change': 'Vui lòng cung cấp lý do cho sự thay đổi',
  'please.save.record.first': 'Vui lòng lưu hồ sơ trước',
  'please.select': 'Vui lòng chọn',
  'please.select.date.range': 'Vui lòng chọn khoảng thời gian',
  'select.date': 'Thời Gian',
  'revenue': 'Doanh Thu',
  'please.select.language': 'Vui lòng chọn ngôn ngữ',
  'pricing': 'Bảng Giá',
  'process.and.save.drafts': 'Xử Lý & Lưu Nháp',
  'process.and.view': 'Xử Lý & Xem',
  'processed.data': 'Dữ liệu đã xử lý',
  'processed.files': 'Tệp Đã Xử Lý',
  'processing': 'Đang Xử Lý',
  'processing.complete': 'Hoàn Thành Xử Lý',
  'processing.in.progress': 'Đang Xử Lý',
  'processing.note': 'Lưu Ý',
  'processing.records': 'Hồ Sơ Đang Xử Lý',
  'province': 'Tỉnh',
  'province.filter': 'Lọc Theo Tỉnh',
  'rate': 'Tỷ Lệ',
  'rate.percentage': 'Tỷ Lệ (%)',
  'rate.validation.message': 'Tỷ lệ phải từ 0 đến 1 (ví dụ: 0.045 cho 4.5%)',
  'raw.processed.data': 'Dữ Liệu Thô Đã Xử Lý',
  'reason': 'Lý Do',
  'reason.for': 'Lý do cho',
  'receipt.image': 'Ảnh hóa đơn',
  'receipt.image.processing': 'Xử lý ảnh hóa đơn',
  'recent.shipments': 'Vận Chuyển Gần Đây',
  'record.restored.successfully': 'Hồ sơ đã được khôi phục thành công',
  'record.saved.pending': 'Hồ sơ đã được lưu ở trạng thái chờ.',
  'record.saved.successfully': 'Bản ghi đã được lưu thành công dưới dạng nháp',
  'records.saved.as.drafts': 'Các bản ghi đã được lưu dưới dạng nháp. Bạn có thể xem xét và hoàn thiện chúng sau.',
  'refresh': 'Làm Mới',
  'registration.expiry': 'Hết Hạn Đăng Ký',
  'remove': 'Xóa',
  'required.field': 'Trường này là bắt buộc',
  'restore': 'Khôi Phục',
  'results': 'Kết Quả',
  'retry': 'Thử Lại',
  'retrying': 'Đang thử lại',
  'review.finalize.below': 'Xem xét và hoàn thiện bên dưới',
  'route': 'Tuyến Đường',
  'save': 'Lưu',
  'save.as.draft': 'Lưu nháp',
  'saved': 'Đã Lưu',
  'saving': 'Đang Lưu',
  'search': 'Tìm kiếm',
  'select.district': 'Chọn Quận/Huyện',
  'select.import.file': 'Chọn Tệp Để Nhập',
  'select.model': 'Chọn',
  'select.province': 'Chọn Tỉnh',
  'select.province.to.filter.districts': 'Chọn tỉnh để lọc quận/huyện',
  'select.timezone': 'Chọn múi giờ',
  'selected.districts': 'Quận/Huyện Đã Chọn',
  'selected.files': 'Tệp Đã Chọn',
  'selected.model': 'Mô Hình Đã Chọn',
  'shop': 'Cửa Hàng',
  'showing.results': 'Hiển thị {start} đến {end} trong tổng số {total} kết quả',
  'speed': 'Tốc Độ',
  'status': 'Trạng Thái',
  'stopped': 'Đang Dừng',
  'success.created': 'Tạo cấu trúc phí thành công',
  'success.deleted': 'Xóa cấu trúc phí thành công',
  'success.updated': 'Cập nhật cấu trúc phí thành công',
  'successful': 'Thành Công',
  'sync': 'Đồng Bộ',
  'tax': 'Thuế',
  'tax.rate': 'Tỷ Lệ Thuế',
  'theme': 'Giao Diện',
  'theme.dark': 'Tối',
  'theme.light': 'Sáng',
  'time': 'Thời Gian',
  'time.period': 'Khoảng Thời Gian',
  'timezone': 'Múi Giờ',
  'to.date': 'Đến Ngày',
  'to.draft': 'Chuyển về nháp',
  'tons': 'tấn',
  'total.amount': 'Tổng Tiền',
  'total.costs': 'Tổng Chi Phí',
  'total.distance': 'Tổng Quãng Đường',
  'total.files': 'Tổng Số Tệp',
  'total.records': 'Tổng Số Bản Ghi',
  'total.shipments': 'Tổng Số Lần Vận Chuyển',
  'tps.logistics.login': 'Đăng Nhập TPS Logistics',
  'trips': 'Chuyến',
  'two.processing.modes': 'Hai Chế Độ Xử Lý',
  'type': 'Loại',
  'unknown': 'Không Rõ',
  'unknown.station': 'Trạm Không Xác Định',
  'unlink': 'Hủy Liên Kết',
  'unlinked': 'Chưa Liên Kết',
  'unlinked.records': 'Hồ Sơ Chưa Liên Kết',
  'update': 'Cập Nhật',
  'update.receipt': 'Cập nhật hóa đơn',
  'update.tax.rate': 'Cập Nhật Tỷ Lệ Thuế',
  'updated': 'Đã Cập Nhật',
  'view': 'Xem',
  'view.all': 'Xem Tất Cả',
  'view.current.file': 'Xem tệp hiện tại',
  'view.current.image': 'Xem ảnh hiện tại',
  'view.image': 'Xem hình ảnh',
  'view.records': 'Xem Bản Ghi',
  'welcome.back': 'Chào mừng trở lại',
  'worst': 'Tồi Nhất',
  'worst.efficiency': 'Hiệu Suất Tồi Nhất',
  'year': 'Năm Sản Xuất',
  'yes': 'Có',
  'yes.delete': 'Có, Xóa',

  // Job History / Processing History
  'processing.history': 'Lịch Sử Xử Lý',
  'no.jobs.found': 'Không tìm thấy công việc xử lý nào cho bộ lọc đã chọn.',
  'completed': 'Hoàn Thành',
  'failed': 'Thất Bại',
  'source': 'Nguồn',
  'days': 'Ngày',
  'apply': 'Áp Dụng',
  'reset': 'Đặt Lại',
  'completed.at': 'Hoàn Thành Lúc',
  'processing.time': 'Thời Gian Xử Lý',
  'error.reason': 'Lỗi / Lý Do',
  'all.sources': 'Tất Cả Nguồn',
  'all.statuses': 'Tất Cả Trạng Thái',
  'no.retry.available': 'Không thể thử lại',
  'confirm.delete.job': 'Xóa công việc cho "{fileName}"?',
};
